import types from '../actionTypes';

const initialState = {
	isHidden: true,
	isLoading: false,
	mode: null,
	test: null,
	activeGroup: null,
	activeTask: null,
	currentPage: [1],
	mobileActive: false,
};

function editorReducer(state = initialState, action) {
	switch (action.type) {
		case types.SET_EDITOR_ACTIVE_TEST:
			return {
				...state,
				test: action.test,
			};
		case types.SET_TEST_NAME:
			return {
				...state,
				test: {
					...state.test,
					nazwa: action.name,
				},
			};
		case types.SET_EDITOR_ACTIVE_TASK:
			return {
				...state,
				activeTask: action.taskID,
			};
		case types.SET_TEST_FILTERS:
			return {
				...state,
				test: {
					...state.test,
					wybrane_filtry: action.filters,
				},
			};
		case types.ADD_EDITOR_TASK:
			return {
				...state,
				test: {
					...state.test,
					tasks: [
						...state.test.tasks.slice(0, action.index),
						action.task,
						...state.test.tasks.slice(action.index),
					],
					liczba_pytan: Number(state.test.liczba_pytan) + 1,
				},
			};
		case types.DELETE_EDITOR_TASK:
			return {
				...state,
				test: {
					...state.test,
					tasks: state.test.tasks.filter((task) => task['id_pytania'] !== action.taskID),
					liczba_pytan: Number(state.test.liczba_pytan) - 1,
				},
			};
		case types.MOVE_EDITOR_TASK:
			return {
				...state,
				test: {
					...state.test,
					tasks: action.tasks,
				},
			};
		case types.SET_EDITOR_TASKS:
			return {
				...state,
				test: {
					...state.test,
					groups: [
						...state.test.groups.filter((group) => group.id !== action.groupID),
						{
							...state.test.groups.find((group) => group.id === action.groupID),
							tasks: action.tasks,
						},
					],
				},
			};
		case types.SET_EDITOR_PDF:
			return {
				...state,
				test: {
					...state.test,
					testPDF: action.testPDF,
					keyPDF: action.keyPDF,
				},
			};
		case types.OPEN_EDITOR_MODULES:
			return {
				...state,
				mobileActive: true,
			};
		case types.CLOSE_EDITOR_MODULES:
			return {
				...state,
				mobileActive: false,
			};
		case types.RESET_EDITOR: //SAVE_TEST??
			return {
				...initialState,
				mobileActive: state.mobileActive,
				isHidden: state.isHidden,
				mode: state.mode,
			};
		case types.FADE_IN_MODULE:
			return {
				...state,
				isHidden: action.moduleName === 'editor' ? false : state.isHidden,
			};
		case types.SET_EDITOR_MODE:
			return {
				...state,
				mode: action.payload,
			};
		default:
			return state;
	}
}

export default editorReducer;
